import React from 'react';
import { Link } from 'react-router-dom';

import LinkedVariantsTooltip from '../probands_samples/LinkedVariantsTooltip';
import type { SampleDetail } from './types';

type SampleDetailSideSectionProps = {
  sample?: SampleDetail;
};

const SampleDetailSideSection = ({ sample }: SampleDetailSideSectionProps) => {
  const probandId = sample?.subject.externalid ?? '';
  const additionalSamples = sample?.additional_samples ?? [];

  return (
    <div className="sample-detail__side-section">
      <div className="sample-detail__side-title">
        Other samples for proband: {probandId}
      </div>
      {additionalSamples.length > 0 ? (
        <div className="sample-detail__other-samples-list">
          {additionalSamples.map((additionalSample) => (
            <LinkedVariantsTooltip
              key={additionalSample.id}
              variants={additionalSample.genotype_variants || []}
              showLinks={true}
            >
              <Link
                className="sample-detail__other-sample"
                to={`/samples/${additionalSample.id}`}
              >
                {additionalSample.sample_id}
              </Link>
            </LinkedVariantsTooltip>
          ))}
        </div>
      ) : (
        <div className="sample-detail__empty-value">
          No other samples for proband.
        </div>
      )}
    </div>
  );
};

export default SampleDetailSideSection;
